// extracted by mini-css-extract-plugin
export var ingCardContainer = "index-module--ingCardContainer--2T3iC";
export var placeHolder = "index-module--placeHolder--TP0Vs";
export var ingCardImageContainer = "index-module--ingCardImageContainer--2abS_";
export var ingCardImage = "index-module--ingCardImage--3T8FU";
export var ingCardText = "index-module--ingCardText--2niWx";
export var redeemedText = "index-module--redeemedText--3xTIU";
export var redemedImg = "index-module--redemedImg--JHLCC";
export var checkContainer = "index-module--checkContainer--1RgH-";
export var check = "index-module--check--S9yNv";